export const sessionConstants = {
  UNKNOWN_ACTION_TYPE: 'UNKNOWN_ACTION_TYPE',

  SESSION_EXPIRED: 'SESSION_EXPIRED',
  ALERT_SESSION_EXPIRED: 'Your session has already expired. Please sign in again.',
  SERVER_LIMIT_EXCEEDED: 'Oops! That was too quick. Please try again in a minute.',
};
